import { IconButton, Snackbar } from '@mui/material';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';

type Props = {
  onSuccess?: any;
};

export const ToastMessage = forwardRef((props: Props, ref) => {
  const [state, setState] = useState<any>({ show: false });

  const toggleShow = (bodyMsg: string, isError = false) => {
    setState({ show: true, body: bodyMsg, error: isError ? 'warning' : false });
  };

  useImperativeHandle(ref, () => ({
    toggleShow,
  }));

  function handleClose() {
    setState({ ...state, show: false });
  }

  const action = (
    <React.Fragment>
      {/*       <Button color="secondary" size="small" onClick={handleClose}>
        UNDO
      </Button> */}
      <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return <Snackbar open={state.show} autoHideDuration={6000} onClose={handleClose} message={state.body} action={action} />;
});

ToastMessage.displayName = 'ToastMessage';
